import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import atportLogo from "atport_logo.svg";
import Button from "components/Button";
import color from "constants/color";

const Wrap = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${color.white};
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  text-align: center;
`;
const Logo = styled.img`
  width: 318px;
`;
const Label = styled.p`
  font-size: 32px;
  font-weight: bold;
`;
const Description = styled.p`
  font-size: 16px;
  color: ${color.text.gray};
  margin-top: -20px;
`;

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Wrap>
      <Content>
        <Logo src={atportLogo} alt="at PORT" />
        <Label>404 : Not Found</Label>
        <Description>指定されたページ、またはディレクトリは存在しません。</Description>
        <Button label="トップページへ" width="160px" type="secondary" onClick={() => navigate("/")} />
      </Content>
    </Wrap>
  );
};

export default NotFound;
